export default __webpack_public_path__ + "static/media/branch.3f85166b.png";